export const festivalShopConfig = {
  showTopBarCallout: false,
  allowPurchasing: true,
  showReusableCategory: true,
  showBoothConfirmationCheckbox: false,
}
